import { render, staticRenderFns } from "./uusi-kayttaja.vue?vue&type=template&id=3e9ea96c&scoped=true&"
import script from "./uusi-kayttaja.vue?vue&type=script&lang=ts&"
export * from "./uusi-kayttaja.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-kayttaja.vue?vue&type=style&index=0&id=3e9ea96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9ea96c",
  null
  
)

export default component.exports